/**
 * Animation timing constants for slide-in menu and funnel transitions
 *
 * These constants coordinate a multi-step animation sequence:
 * 1. Old content fades out (FUNNEL_ANIMATION_DURATION_MS)
 * 2. Wait for FUNNEL_MEASUREMENT_DELAY_MS before measuring new content
 * 3. New content fades in while container resizes (both BOX_RESIZE_DURATION_MS)
 *
 * The delay prevents measuring stale content during the crossfade.
 */

/**
 * Duration for slide-in menu entry/exit animations
 * Used for both reader mode (translateX) and non-reader mode (translateY)
 * Unified at 300ms for consistent feel across all menu transitions
 */
export const SLIDE_IN_ANIMATION_DURATION_MS = 300;

/**
 * Duration of funnel content crossfade animations (fade-in/fade-out)
 * Used by AnimatePresence mode="wait" in useFunnel.tsx
 */
export const FUNNEL_ANIMATION_DURATION_MS = 200;

/**
 * Buffer time added to ensure animation completes before measurement
 * Provides margin for browser rendering delays and RAF timing
 */
export const FUNNEL_ANIMATION_BUFFER_MS = 10;

/**
 * Total time to wait before measuring new content height
 *
 * This delay is critical for accurate measurements:
 * - Allows exit animation to fully complete (200ms)
 * - Adds buffer for browser processing (10ms)
 * - Ensures we measure the NEW content, not the old content
 *
 * Used with requestAnimationFrame to guarantee DOM has settled
 * before measurement in useContentHeightMeasurement hook.
 */
export const FUNNEL_MEASUREMENT_DELAY_MS = FUNNEL_ANIMATION_DURATION_MS + FUNNEL_ANIMATION_BUFFER_MS;

/**
 * Duration for box width/height resize transitions
 * Matches FUNNEL_ANIMATION_DURATION_MS for synchronized resizing
 * Applied via CSS transitions with cubic-bezier easing
 */
export const BOX_RESIZE_DURATION_MS = 200;

/**
 * Bottom padding for payment components when fixed footer is enabled
 * Creates space for the portal-rendered fixed footer to allow content to scroll above it
 * Used in payment modals to prevent content from being hidden behind fixed footer
 */
export const FIXED_FOOTER_PADDING_PX = "96px";
